<template>
  <div class="chart-dimensions" :style="{ padding: maxDimensionPx / 2 + 'px' }">
    <div class="line">
      <div
        :class="[
          'dot',
          {
            selected: getPaint.id === datum.id,
            extremity:
              datum.width * datum.height === minArea ||
              datum.width * datum.height === maxArea
          }
        ]"
        v-for="datum in $ml.get('data')"
        :key="datum.id"
        :style="{
          left: `calc(${scaleArea(
            datum.shape === 'cerchio'
              ? datum.width * Math.PI
              : datum.width * datum.height
          )}% - 1.5px)`
        }"
      >
        <div
          class="reference-area"
          v-if="
            datum.width * datum.height === minArea ||
              datum.width * datum.height === maxArea
          "
          :style="{
            width: scaleDimension(datum.width) + 'px',
            height: scaleDimension(datum.height) + 'px'
          }"
        >
          <div class="area-label">
            {{ datum.width }}x{{ datum.height }}<br />{{
              datum.width * datum.height === minArea
                ? $ml.get("content").chart_dimension_first_label
                : $ml.get("content").chart_dimension_last_label
            }}
          </div>
        </div>
      </div>
      <div
        :class="['area', { circle: getPaint.shape === 'cerchio' }]"
        :style="{
          left: `calc(${scaleArea(
            getPaint.shape === 'cerchio'
              ? getPaint.width * Math.PI
              : getPaint.width * getPaint.height
          )}% + 1.5px)`,
          width: scaleDimension(getPaint.width) + 'px',
          height: scaleDimension(getPaint.height) + 'px'
        }"
      >
        <div class="area-label">
          <template v-if="getPaint.shape === 'cerchio'">{{
            getPaint.width
          }}</template>
          <template v-else>
            {{ getPaint.width }}x{{ getPaint.height }}</template
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "chart-dimensions",
  props: {
    maxDimensionPx: { default: 100 }
  },
  computed: {
    maxArea() {
      let maxPaint = _.maxBy(this.$ml.get("data"), d => d.width * d.height);
      return maxPaint.width * maxPaint.height;
    },
    minArea() {
      let minPaint = _.minBy(this.$ml.get("data"), d => d.width * d.height);
      return minPaint.width * minPaint.height;
    },
    maxDimension() {
      let maxWidth = _.maxBy(this.$ml.get("data"), d => d.width).width;
      let maxHeight = _.maxBy(this.$ml.get("data"), d => d.height).height;
      return Math.max(maxWidth, maxHeight);
    },
    minDimension() {
      let maxWidth = _.minBy(this.$ml.get("data"), d => d.width).width;
      let maxHeight = _.minBy(this.$ml.get("data"), d => d.height).height;
      return Math.min(maxWidth, maxHeight);
    },
    ...mapGetters(["getPaint"])
  },
  methods: {
    scaleArea(area) {
      return (area * 100) / this.maxArea;
    },
    scaleDimension(dimension) {
      return (
        ((dimension - this.minDimension) * this.maxDimensionPx) /
          this.maxDimension +
        this.minDimension
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-dimensions {
  width: 100%;
  .line {
    width: 100%;
    position: relative;
    height: 1px;
    background: rgba(#979797, 0.5);
    .dot {
      position: absolute;
      top: -1px;
      height: 3px;
      width: 3px;
      border-radius: 50%;
      background: rgba($primary, 0.43);
      transition: all 0.5s ease;
      @media (max-width: 720px) {
        background: transparent;
      }
      .reference-area {
        position: absolute;
        top: 2px;
        left: 2px;
        transform: translate(-50%, -50%);
        border-radius: 2px;
        background-color: rgba(255, 255, 255, 0.15);
        .area-label {
          position: absolute;
          bottom: -37px;
          width: 150px;
          text-align: center;
          left: calc(50% - 75px);
          @include number-secondary_dark-center;
        }
      }
      &.selected,
      &.extremity {
        background: $white;
        top: -2px;
        height: 5px;
        width: 5px;
        z-index: 1;
      }
    }
    .area {
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-50%, -50%);
      border-radius: 2px;
      background: rgba($primary, 0.5);
      transition: left 0.5s ease, width 0.7s ease, height 0.7s ease;
      &.circle {
        border-radius: 50%;
      }
      .area-label {
        position: absolute;
        top: -20px;
        width: 80px;
        text-align: center;
        left: calc(50% - 40px);
        @include number-white-center;
      }
    }
  }
}
</style>
